import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useGetFeatureFlagsQuery } from "@services/featureFlagsApi";
import { setFeatureFlags } from "@features/featureFlags/featureFlagsSlice";

export const useFetchFeatureFlags = () => {
  const dispatch = useDispatch();

  const { data, isError, isFetching } = useGetFeatureFlagsQuery();

  useEffect(() => {
    if (!isFetching && !isError && data) {
      dispatch(setFeatureFlags(data));
    }
  }, [data, isError, dispatch, isFetching]);
};
